import { createTheme } from '@mui/material';
import { jaJP as coreJaJP } from '@mui/material/locale';
import { jaJP } from '@mui/x-date-pickers';

const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#1a96f0',
      },
      secondary: {
        main: '#1A96F0',
        light: '#ffffff',
      },
      error: {
        main: '#ff0000',
      },
    },
    typography: {
      fontFamily: 'Meiryo, Hiragino, sans-serif',
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: '#db3131',
            '&$error': {
              color: '#db3131',
            },
          },
        },
      },
    },
  },
  jaJP,
  coreJaJP
);

export default theme;
